<div
  class="origin-modal-content"
  nxModalContent
>
  <div class="modal-header">
    @if (status()) {
      <allianz-status-icon
        size="m"
        [type]="status()"
      ></allianz-status-icon>
    }
    <h2
      nxHeadline
      size="l"
      class="nx-font-weight-regular"
    >
      {{ title() }}
    </h2>
  </div>
  <div class="modal-content">
    <ng-content></ng-content>
  </div>
</div>
<div
  class="modal-actions"
  nxModalActions
>
  <allianz-button-group
    class="action-buttons"
    [buttons]="buttons()"
  ></allianz-button-group>
</div>
